// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectHelpPage2_container__1Nwwq","text":"ProjectHelpPage2_text__DlWWP","image":"ProjectHelpPage2_image__1mdNP"};